import { AnnotationIconColorType, AnnotationIconType } from '@/api/storymapCardDetails/queries';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createEditAnnotationCommand } from '../../../api/commands/factory/createAnnotationCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class EditAnnotation extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'EditAnnotation';

    public constructor(public id: string, public name: string, public icon: AnnotationIconType, public color: AnnotationIconColorType) {
        super(EditAnnotation.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: EditAnnotation): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createEditAnnotationCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: EditAnnotation): void => {
    const annotation = state.annotations.find((x) => x.id === action.id);

    annotation.color = action.color;
    annotation.icon = action.icon;
    annotation.name = action.name;
    annotation.isEmoji = false;
};

//@ts-ignore
registerMiddleware(EditAnnotation.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(EditAnnotation.ACTION_TYPE, reducer);
